import React, { useState } from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';
import logo from './navbarlogo.png';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null); // Aktif alt menü

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setActiveMenu(null); // Menü açıldığında alt menüleri sıfırla
  };

  const toggleSubMenu = (menu) => {
    setActiveMenu(activeMenu === menu ? null : menu); // Alt menüyü aç/kapat
  };

  const altBasliklar = {
    Hakkımızda: [
      { name: 'Biz Kimiz', path: '/hakkimizda/biz-kimiz' },
      { name: 'Yönetim', path: '/hakkimizda/yonetim' },
      { name: 'Organizasyon Şemamız', path: '/hakkimizda/organizasyon' },
      { name: 'Kalite Politikamız', path: '/hakkimizda/kalite' },
      { name: 'Misyonumuz', path: '/hakkimizda/misyon' },
      { name: 'Vizyonumuz', path: '/hakkimizda/vizyon' },
    ],
    Birimlerimiz: [
      { name: 'Kalite Yönetim Birimi', path: '/birimler/kalite-yonetim' },
      { name: 'Numune Kabul ve Raporlama Birimi', path: '/birimler/numune-kabul' },
      { name: 'Fiziksel Analiz Laboratuvarı', path: '/birimler/fiziksel-analiz' },
      { name: 'Kimyasal Analiz Laboratuvarı', path: '/birimler/kimyasal-analiz' },
      { name: 'Mikrobiyoloji Analiz Laboratuvarı', path: '/birimler/mikro-analiz' },
    ],
    Belgelerimiz: [
      { name: 'Akreditasyon Sertifikası', path: '/belgeler/akreditasyon-sertifikasi' },
      { name: 'Akreditasyon Kapsamı', path: '/belgeler/akreditasyon-kapsami' },
    ],
    Müşteri: [
      { name: 'Analiz Kapsam Listesi', path: '/musteri/analiz-kapsam' },
      { name: 'Numune Kabul Şartları ve Formu', path: '/musteri/numune-kabul' },
      { name: 'İstek ve Şikayetler', path: '/musteri/istek-sikayet' },
      { name: 'Banka Hesap Bilgileri', path: '/musteri/banka-bilgileri' },
    ],
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <div className="navbar-logo">
          <Link to="/" onClick={() => setIsMenuOpen(false)}>
            <img src={logo} alt="Site Logo" className="logo-image" />
          </Link>
        </div>

        {/* Burger Bar */}
        <button className="menu-toggle" onClick={toggleMenu}>
          {isMenuOpen ? '✖' : '☰'}
        </button>

        {/* Menü */}
        <ul className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <li>
            <Link to="/" onClick={() => setIsMenuOpen(false)}>Anasayfa</Link>
          </li>

          {/* Alt Başlık Yapısı */}
          {Object.keys(altBasliklar).map((baslik) => (
            <li
              key={baslik}
              className={`has-submenu ${activeMenu === baslik ? 'open' : ''}`}
              onMouseEnter={() => !isMenuOpen && setActiveMenu(baslik)} // Masaüstü hover
              onMouseLeave={() => !isMenuOpen && setActiveMenu(null)} // Masaüstü hover dışı
              onClick={() => isMenuOpen && toggleSubMenu(baslik)} // Mobil tıklama
            >
              <span className="main-link">{baslik}</span>
              <ul
                className={`submenu ${
                  activeMenu === baslik ? 'submenu-visible' : ''
                }`}
              >
                {altBasliklar[baslik].map((altBaslik, index) => (
                  <li key={index}>
                    <Link
                      to={altBaslik.path} // Path değerlerini buradan kontrol edersiniz
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {altBaslik.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
          ))}
          <li>
            <Link to="/iletisim" onClick={() => setIsMenuOpen(false)}>İletişim</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
